import { axios } from '@/utils';

export const getAllCanceledProductsService = async () =>
  (await axios.get('product-logs')).data.data;

export const getCanceledProductsByIdService = (id: string) => async () =>
  (await axios.get(`product-logs/${id}`)).data.data;

export const createCanceledProducts = async (id? : string,body?: any) =>
  (await axios.post('product-logs/list', body)).data.data;
